import { render } from "./TaskParameters.vue?vue&type=template&id=10d0ebfc"
import script from "./TaskParameters.vue?vue&type=script&lang=js"
export * from "./TaskParameters.vue?vue&type=script&lang=js"

import "./TaskParameters.vue?vue&type=style&index=0&id=10d0ebfc&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__